import { useState, useEffect } from "react";
import Loader from "../../assets/images/loader.gif";

const ProgressiveImg = ({ src, ...props }) => {
  const [imgSrc, setImgSrc] = useState(Loader || src);

  useEffect(() => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      setImgSrc(src);
    };
  }, [src]);

  const customCss =
  Loader && imgSrc === Loader ? {objectFit: 'contain',width: '30%'} : props?.style ? props.style : {};

  return (
    <img
      {...{ src: imgSrc, ...props }}
      alt={props.alt || ""}
      style={customCss}
      className={props.class || ""}
    />
  );
};
export default ProgressiveImg;
